import React, { useLayoutEffect, useRef, useState } from "react";
import ReactDevicePreview from "react-device-preview";

const LoadPreviewWithDevice = ({
  classes = "",
  random,
  width,
  height,
  getStorePreviewURL,
  device = "iphonex",
  color = "gray",
  scale = 0.7,
  fitMaxWidth,
  fitMaxHeight,
  fitMaxScale = 1,
}) => {
  const measureRef = useRef(null);
  const [fitScale, setFitScale] = useState(Number(scale) || 0.7);

  const useFit =
    typeof fitMaxWidth === "number" &&
    typeof fitMaxHeight === "number" &&
    fitMaxWidth > 0 &&
    fitMaxHeight > 0;

  useLayoutEffect(() => {
    if (!useFit) return;

    const root = measureRef.current;
    if (!root) return;

    const deviceEl = root.querySelector(".marvel-device");
    if (!deviceEl) return;

    const deviceW = deviceEl.offsetWidth;
    const deviceH = deviceEl.offsetHeight;

    if (!deviceW || !deviceH) return;

    const cap = Number.isFinite(fitMaxScale) ? fitMaxScale : 1;

    setFitScale(Math.min(cap, fitMaxWidth / deviceW, fitMaxHeight / deviceH));
  }, [useFit, fitMaxWidth, fitMaxHeight, fitMaxScale, random, width, height]);

  const iframe = (
    <iframe
      key={random}
      title="Store ordering preview"
      className={classes}
      width={width}
      height={height}
      src={getStorePreviewURL()}
      scrolling="yes"
      style={{
        border: 0,
        display: "block",
        width,
        height,
      }}
    />
  );

  if (!useFit) {
    return (
      <div style={{ transformOrigin: "top center" }}>
        <ReactDevicePreview device={device} color={color} scale={scale}>
          {iframe}
        </ReactDevicePreview>
      </div>
    );
  }

  return (
    <div
      className="relative flex items-start justify-center overflow-hidden"
      style={{
        width: fitMaxWidth,
        height: fitMaxHeight,
      }}
    >
      <div
        ref={measureRef}
        style={{
          transform: `scale(${fitScale})`,
          transformOrigin: "top center",
        }}
      >
        <ReactDevicePreview device={device} color={color} scale={1}>
          {iframe}
        </ReactDevicePreview>
      </div>
    </div>
  );
};

export default LoadPreviewWithDevice;